// extracted by mini-css-extract-plugin
export default {"wrapper":"apolloDayPicker_wrapper__jSCaD","rdp_day_content":"apolloDayPicker_rdp_day_content__-VqT-"};